// extracted by css-extract-rspack-plugin
export default {"SectionCard":"oUUdf","CardLinksSection":"cA4Cl"};